import React, { ComponentType } from "react"

import DatoPullQuoteBlock from "../../../dato-components/dato-pull-quote-block"
import BlogAccordion from "./blog-accordion"
import BlogEmbedVideo from "./blog-embed-video"
import BlogImage from "./blog-image"
import BlogLinkedImage from "./blog-linked-image"
import BlogHtmlTable from "./blog-table/html-table"
import BlogTable from "./blog-table/json-table"
import CallToAction from "./call-to-action"
import CallToActionButtons from "./call-to-action-buttons"
import PodcastEmbed from "./podcast-embed"

const blockMap = {
  DatoCms_ImageRecord: BlogImage,
  DatoCms_LinkedImageRecord: BlogLinkedImage,
  DatoCms_AccordionRecord: BlogAccordion,
  DatoCms_TableRecord: BlogTable,
  DatoCms_EmbedVideoRecord: BlogEmbedVideo,
  DatoCms_TextBasedCallToActionRecord: CallToAction,
  DatoCms_HtmlTableRecord: BlogHtmlTable,
  DatoCms_PodcastEmbedRecord: PodcastEmbed,
  DatoCms_ButtonsBasedCallToActionRecord: CallToActionButtons,
  DatoCms_PullQuoteRecord: DatoPullQuoteBlock,
} as const

type BlockMap = typeof blockMap
type BlockKey = keyof BlockMap
type SpecificProps<K extends BlockKey> = Parameters<BlockMap[K]>[0]

export type BlockProps = {
  [K in BlockKey]: SpecificProps<K> & {
    __typename: K
    id: string
  }
}[BlockKey]

function Block(record: BlockProps) {
  const { __typename: typename } = record
  const Component = blockMap[typename] as ComponentType<BlockProps>
  return <Component {...record} />
}

export default Block
